import {css} from 'lit';
export const styles = css`a{cursor:pointer;text-decoration:none;position:relative;display:block}:host :hover{--iff-hover__font--color:var(--iff-alias__color--complement)}:host([active="true"]){--iff-hover__font-color:var(--iff-alias__color--accent-one)}`;
export default styles;
